import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { SHIMMER_SWEEP_CLASS } from '@/components/ui/motion';

const ShimmerOverlay: React.FC<BoxProps> = (props) => (
	<Box position="absolute" inset={0} pointerEvents="none" className={SHIMMER_SWEEP_CLASS} {...props} />
);

export default ShimmerOverlay;
